module.exports = __webpack_public_path__ + "img/percentage.f98b1471.png";